import { useRef } from 'react';
import cn from 'classnames';
import styles from 'styles/pages/index.module.scss';
import Volanta from '@/components/Volanta';
import Pointer from '@/components/Svgs/pointer';
import HopLogo from '@/components/Svgs/hoplogo';
import RightThings from './RightThings.jsx/index.jsx';
import LeftThings from './LeftThings';
import LineaYTextos from './LineaYTextos';
import Ilustracion from './Ilustracion';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import CyanDot from './CyanDot/index.jsx';
import GreyDot from './GreyDot/index.jsx';
import { useIsomorphicLayoutEffect } from '@/helpers/isomorphicEffect';

gsap.registerPlugin(ScrollTrigger);

const ElegirnosAnimacion = ({ choose_reasons }) => {
  const root = useRef(null);

  useIsomorphicLayoutEffect(() => {
    if (!root.current) return;
    const el = root.current;

    const all = (sel) => el.querySelectorAll(sel);
    const one = (sel) => el.querySelector(sel);

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        toggleActions: 'play none none none',
        markers: false
      }
    });

    if (all('.top-item-js').length) tl.fromTo(all('.top-item-js'), { scale: 0 },
      { scale: 1, duration: 0.6, stagger: 0.5, ease: 'back.out' }, 0);
    if (all('.gradient-line-js').length) tl.fromTo(all('.gradient-line-js'), { scaleX: 0 },
      { scaleX: 1, ease: 'expo.out', stagger: 0.6 }, 0.1);
    if (one('.image-2-js')) tl.fromTo(one('.image-2-js'), { autoAlpha: 0, xPercent: -10 },
      { autoAlpha: 1, xPercent: 0 }, 0.5);
    if (one('.image-3-js')) tl.fromTo(one('.image-3-js'), { autoAlpha: 0, xPercent: 10 },
      { autoAlpha: 1, xPercent: 0 }, 0.7);
    if (one('.image-1-js')) tl.fromTo(one('.image-1-js'), { autoAlpha: 0, xPercent: -10 },
      { autoAlpha: 1, xPercent: 0 }, 0.9);
    if (one('.image-4-js')) tl.fromTo(one('.image-4-js'), { autoAlpha: 0, xPercent: 10 },
      { autoAlpha: 1, xPercent: 0 }, 1.1);
    if (one('.large-line-js')) tl.fromTo(one('.large-line-js'), { scaleX: 0 },
      { scaleX: 1, duration: 0.5, ease: 'expo.out' }, 1.3);
    if (all('.pointer-js').length) tl.fromTo(all('.pointer-js'),
      { scale: 0, y: 10, autoAlpha: 0 },
      { scale: 1, y: 0, autoAlpha: 1, ease: 'back.out', stagger: 0.2 }, 1.3);
    if (all('.bottom-text-js').length) tl.fromTo(all('.bottom-text-js'),
      { y: 10, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, ease: 'power2.out', stagger: 0.2 }, 1.3);

    const refresh = () => ScrollTrigger.refresh();
    const ids = [
      requestAnimationFrame(refresh),
      setTimeout(refresh, 100),
      setTimeout(refresh, 500),
      setTimeout(refresh, 1500)
    ];
    document.fonts?.ready?.then(refresh);
    window.addEventListener('load', refresh);

    return () => {
      cancelAnimationFrame(ids[0]);
      clearTimeout(ids[1]);
      clearTimeout(ids[2]);
      clearTimeout(ids[3]);
      window.removeEventListener('load', refresh);
      tl.scrollTrigger?.kill();
      tl.kill();
    };
  }, []);

  return (
    <>
      <div
        ref={root}
        className={cn(
          styles.shadow,
          'relative z-1 w-full lg:w-[111rem] pt-30 px-20 sm:px-95 pb-55 mx-auto rounded-[3rem] sm:rounded-[5.4rem] bg-white | wrapper-enter'
        )}
      >
        <LeftThings />
        <RightThings />
        <div className="flex items-end justify-between mb-50 sm:mb-20">
          <div className="opacity-90">
            <Volanta label={'por qué eligirnos'} />
          </div>
          <div className="flex items-end">
            <div className="origin-center | top-item-js">
              <CyanDot />
            </div>
            <div
              className={cn(
                'w-25 sm:w-50 h-1 mx-8 origin-left | gradient-line-js',
                styles.gradientLine
              )}
            ></div>
            <div className="w-34 h-34 sm:w-43 sm:h-43 rounded-full bg-red flex items-center justify-center | top-item-js">
              <div className="w-14 sm:w-19">
                <HopLogo />
              </div>
            </div>
            <div
              className={cn(
                'w-25 sm:w-50 h-1 mx-8 origin-left | gradient-line-js',
                styles.gradientLine
              )}
            ></div>
            <div className="origin-center | top-item-js">
              <GreyDot />
            </div>
          </div>
          <div className="hidden sm:block opacity-0 pointer-events-none select-none">
            <Volanta label={'por qué eligirnos'} />
          </div>
        </div>
        <div className="mb-100 sm:mb-30 flex justify-center">
          <div className="relative w-full lg:w-[83.4rem] aspect-[834/272]">
            <Ilustracion />
          </div>
        </div>
        <LineaYTextos choose_reasons={choose_reasons} />
      </div>
    </>
  );
};
export default ElegirnosAnimacion;
